import { render, staticRenderFns } from "./IconAiAgent.vue?vue&type=template&id=34a55a10"
import script from "./IconAiAgent.vue?vue&type=script&lang=js"
export * from "./IconAiAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports